export default "/images/pensam.avif?9113a44172521ec63b23edfe37700bd5";